import React from "react";
import { useState, useEffect } from "react";
import { partnerService } from '../../services/api/partner.service';

import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { DialogDoctor } from "./dialogDoctor";
import { DoctorStenciel } from "./doctorStenciel";
import { alertService } from '../../services/helpers/alert.service';


export const Doctors = (props) => {

    const [doctors, setDoctors] = useState([]);
    const [currentDoctor, setCurrentDoctor] = useState(null);
    const [visibleDialog, setVisibleDialog] = useState(false); 
    const [visibleParafa, setVisibleParafa] = useState(false); 
    const [refresh, setRefresh] = useState(true);

    const partener = sessionStorage.getItem("idPartener");


    const selectDoctor = (doctor) => {
        if (!doctor && partener == 0) {
            alertService.error("Selectati un partener!");
            return;
        }
        setCurrentDoctor(doctor);
        setVisibleDialog(true);
    }

    const viewPafara = (doctor) => {
        if (!doctor && partener == 0) {
            alertService.error("Selectati un partener!");
            return;
        }
        setCurrentDoctor(doctor);
        setVisibleParafa(true);
    }
    

    const toggleDialog = () => {
        setVisibleDialog(!visibleDialog);
    };

    const deleteDoctor = (id) => {
        alertService.confirm("Atentie", "Esti sigura ca vrei sa stergi doctorulul " + doctors[id].nume + " " + doctors[id].prenume + "?"
            , () => { partnerService.deleteDoctor( { id : doctors[id].id } ).then((response) => { setRefresh(true); }); }
            , () => { return; }
        );
        
    }

    const toggleParafa = (id) => {
        setVisibleParafa(!visibleParafa) 
    }


    useEffect(() => {
        if (refresh === false) return;
        partnerService.getDoctors()
            .then((response) => {
                if (response) {
                    setDoctors(response);
                }
                else {
                    setDoctors(null)
                }
            })

        setRefresh(false);
    }, [refresh]);

    return (
        <>
            <div className="clearfix">
                <h2 className="fl">Medici</h2>
                <div className="fr d-flex justify-content-end">
                    <button
                        name="add"
                        className="btn db"
                        onClick={() => selectDoctor()}
                    >
                        Adauga medic
                    </button>
                </div>
            </div>
            <div data-name="mesaj"></div>
            <table className="tbl" data-name="lista" width="100%">
                <thead>
                    <tr>
                        <th>Nume</th>
                        <th>Prenume</th>
                        <th>Parafa</th>
                        <th>CNP</th>
                        <th>Telefon</th>
                        <th>Specialitate</th>
                        <th>Activ</th>
                        <th width="60">Edit</th>
                        <th>Parafa scanata</th>
                    </tr>
                </thead>
                <tbody>
                    {doctors.map((doctor, index) => (
                        <tr key={index}>
                            <td data-name="nume">{doctor.nume}</td>
                            <td data-name="prenume">{doctor.prenume}</td>
                            <td data-name="parafa">{doctor.parafa}</td>
                            <td data-name="cnp">{doctor.cnp}</td>
                            <td data-name="telefon">{doctor.telefon}</td>
                            <td data-name="denspecialitate">{doctor.specialitate}</td>
                            <td data-name="eactiv">{doctor.activ ? "Da" : "Nu"}</td>
                            <td>
                                <a className="icon sterge ml10 mr10 fl"
                                    onClick={() => { deleteDoctor(index) }}
                                    title="Sterge"
                                    data-name="del">
                                    Sterge
                                </a>
                                <a className="icon modifica mr10 fl"
                                    onClick={() => selectDoctor(doctor)}
                                    title="Modifica"
                                    data-name="mod">
                                    Modifica
                                </a>

                            </td>
                            <td>
                            {(doctor.haveStenciel == 1) && <a className="icon parafa ml20"
                                    onClick={() => viewPafara(doctor)}
                                title="Vezi parafa">Modifica</a>
                            }
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {visibleDialog && (
                <Dialog title={"Adauga medic"} onClose={toggleDialog}>
                    <DialogDoctor toggleDialog={toggleDialog} setRefresh={setRefresh} doctor={currentDoctor}  />
                    <DialogActionsBar>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={toggleDialog}
                        >
                            Salveaza
                        </button>
                        <button
                            className="k-button k-button-md k-rounded-md k-button-solid k-button-solid-base"
                            onClick={toggleDialog}
                        >
                            Inchide
                        </button>
                    </DialogActionsBar>
                </Dialog>
                
            )}

            {visibleParafa && <DoctorStenciel toggleParafa={toggleParafa} doctor={currentDoctor}></DoctorStenciel> 

            }
        </>
    );
};
